import Lines from '../../components/Lines';
import "./Library.scss";

const Library = () => {
    return (
        <>
            <section className="libraryPageFirstSection">
                <header>
                    <h2>Library-Learning Resource Centre</h2>
                    <div className="linesParent">
                        <Lines
                            count={25}
                            color="#0D553A"
                            fontSize="2.5"
                        />
                    </div>
                </header>
                <div className="bgImage"></div>
            </section>
            <section className="libraryPageSecondSection">
                <p>
                    Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular Lorem ipsum dolor sit amet consectetur adipisicing elit. Perspiciatis at, iure veritatis nemo rem fuga esse dolorum optio nihil odio sapiente illo aspernatur ratione officia sunt aliquam voluptatem molestias culpa sit dolor ad non voluptas officiis! Minus omnis soluta sed, dolores iure aspernatur quasi praesentium quisquam, distinctio, ullam possimus deleniti tempora voluptatem esse ipsam commodi. Aliquid tenetur pariatur tempore ut distinctio neque nulla, expedita est sapiente molestiae libero vitae! Iste blanditiis hic consequuntur perspiciatis repellat labore sunt saepe quo fuga corporis sapiente possimus quas maiores eveniet voluptate, ! At deleniti numquam ad veniam! during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32.
                </p>
            </section>
        </>
    )
}

export default Library
